import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import NumberUtils from "util/NumberUtils";
const DetailsCell = ({ details }) => {
  const { t } = useTranslation("enterprise_license");
  const trafficLimit = NumberUtils.formatBytes(details.traffic_limit);
  const trafficCheckRange = moment.duration(details.traffic_check_range);
  const expirationWarning = moment.duration(details.expiration_warning_range);
  const versionDetails = () => {
    switch (details.version) {
      case 1:
        return /* @__PURE__ */ React.createElement("p", null, t("license.details.max_nodes", { nodes: details.number_of_nodes }));
      case 2:
      case 4:
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, t("license.details.daily_traffic_limit", {
          limit: trafficLimit,
          days: trafficCheckRange.as("days"),
          violations: details.allowed_traffic_violations
        })), /* @__PURE__ */ React.createElement("p", null, t("license.details.requires_remote_checks", {
          answer: details.require_remote_check ? t("license.details.yes") : t("license.details.no")
        }), details.require_remote_check && ` ${t("license.details.allowed_check_failures", {
          failures: details.allowed_remote_check_failures
        })}`), /* @__PURE__ */ React.createElement("p", null, t("license.details.expiration_warning", { days: expirationWarning.as("days") })));
      case 3:
        if (!details.traffic_limit) {
          return null;
        }
        return /* @__PURE__ */ React.createElement("p", null, t("license.details.remaining_provision", { limit: trafficLimit }));
      default:
        return /* @__PURE__ */ React.createElement("p", null, t("license.details.unknown_version"));
    }
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, details.trial && /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement("strong", null, t("license.details.trial"))), versionDetails());
};
export default DetailsCell;
